import React from 'react'
import Background from './Background'

import SiteHeader from './SiteHeader'
import SegmentedUI from './SegmentedUI'
import SiteFooter from './SiteFooter'
import Privacy from './Privacy'

import { Row, Space } from 'antd'

// The header bar sits OUTSIDE the centred column, so it spans the page the way every sibling's
// does (nodejavascript.com site standard, part 3). Everything else is the column.
const SiteLayout = () => {
  return (
    <Background>
      <SiteHeader />

      <Row align='center' className='dvs-shell'>
        <Space direction='vertical' size='large'>

          <div className='dvs-title-block'>
            <h1 className='dvs-title'>Generate a strong password</h1>
            <p className='dvs-tagline'>The least annoying password generator on the Internet.</p>
          </div>

          <SegmentedUI />

          <Privacy />

          <SiteFooter />

        </Space>
      </Row>
    </Background>
  )
}

export default SiteLayout
